import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import env from "react-dotenv";




export default function Contact() {

  //! Way to see the data in console
  // const [userName, setUserName]= useState('')

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [company, setCompany] = useState('');
  const [message, setMessage] = useState('');
  const [formCompletedMessage, setFormCompletedMessage] = useState(false)
 

  const form = useRef();

  const Result =() =>{
    return(
      <p className='send-message'>Thank you for your message. We will contact you soon!</p>
    )
  }
  
  const sendEmail = (e) => {
    console.log('handleSubmit ran');
    e.preventDefault();
    setName('')
    setEmail('')
    setSubject('')
    setCompany('')
    setMessage('')
    setFormCompletedMessage(true)
    


    //! Way to see the data in console
    // console.log(userName)
    // const formdata = new FormData(e.target)
    // console.log(Object.fromEntries(formdata.entries()))
    
   

    emailjs.sendForm(
    `${process.env.REACT_APP_YOUR_SERVICE_ID}`, 
    `${process.env.REACT_APP_YOUR_TEMPLATE_ID}` , form.current, 
    `${process.env.REACT_APP_YOUR_PUBLIC_KEY}`
    )
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
      setFormCompletedMessage(true)

  };

  

  
  return (
    <div className='contact-body'>
    <div className='contact-content'>
    <h1 className='contact-h1'>CONTACT</h1>
    <span className='line-contact' ></span>
    <p className='contact-text'>Lets Work Together</p>
    <p className='contact-text'>andrey.detochkin[at]gmail.com</p>

    <form className='form' ref={form} onSubmit={sendEmail}>
    <p className='submit-message'>{formCompletedMessage ? <Result/> : null }</p>
        <input className='form-input' type='text'  name='from_name' placeholder='Name*' value={name} onChange={event => setName(event.target.value)}  required/>
        <input className='form-input' type='email' name='reply_to' placeholder='Email*' value={email}  onChange={event => setEmail(event.target.value)} required/>
        <input className='form-input' type='text' name='message_subject' placeholder='Subject*' value={subject} onChange={event => setSubject(event.target.value)} required/>
        <input className='form-input' type='text' name='from_company' placeholder='Company' value={company} onChange={event => setCompany(event.target.value)}/>
        <input className='form-input message'  type='message' name='message' placeholder='Message*' value={message} onChange={event => setMessage(event.target.value)} required/>
        <button className='btn-send' type='submit' value='Send' >Send</button>
       
       
    
        
      </form>
    </div>
   
   
    </div>
  )
}
